'use client';

import React from 'react';

import { CardReview } from '@/components/CardReview';
import { Media } from '@/components/Media';
import { CMSLink } from '@/components/Link';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselControls,
} from '@ui/carousel';
import { Rating } from '@ui/rating';
import { NAV } from '@/constants';
import type { Review, ReviewPlatform } from '@/payload-types';

export const ReviewSlider: React.FC<{
  title: string;
  description: string;
  reviews: Review[];
  platformsTitle: string;
  platformsDescription: string;
  platforms: ReviewPlatform[];
}> = ({
  title,
  description,
  reviews,
  platformsTitle,
  platformsDescription,
  platforms,
}) => {
  const objectReviews = reviews.filter((i) => typeof i === 'object');

  return (
    <section className="v-margin" data-name="ReviewSlider">
      <div className="container">
        <h2 className="h2 mb-5 md:mb-4">{title}</h2>
        <div className="mb-10 md:mb-6">{description}</div>

        <Carousel opts={{ align: 'start', loop: true }}>
          <CarouselContent className="-ml-6">
            {objectReviews.map((doc) => (
              <CarouselItem
                className="flex basis-1/2 pl-6 md:basis-full"
                key={doc.id}
              >
                <CardReview doc={doc} />
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselControls linkText="Все отзывы" linkUrl={NAV.reviewList} />
        </Carousel>

        {/* Platforms  */}
        <div className="v-margin !mb-0">
          <h2 className="h2 mx-auto mb-5 max-w-[820px] text-center md:mb-4">
            {platformsTitle}
          </h2>

          <div className="mb-12 text-center md:mb-6">
            {platformsDescription}
          </div>

          {platforms && platforms.length > 0 && (
            <div className="mx-auto grid max-w-[1026px] grid-cols-2 gap-x-8 gap-y-12 md:gap-x-5 md:gap-y-6">
              {platforms.map((i) => (
                <Media imgClassName="mx-auto" resource={i.logo} key={i.id} />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
